function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import { useRef } from 'react';
import { P, isMatching, match } from 'ts-pattern';
import { Button, Card, Dialog, Divider, Heading, Select, TextInput, Flex, createForm, useId, Box, Text, HelpText } from '@applyboard/crystal-ui';
import { DeleteOutlineIcon, EditOutlineIcon, PlusOutlineIcon } from '@applyboard/ui-icons';
import { shortUUID } from "../../../../utils/id";
import { JsonLogicInput, validateJsonLogicFieldValue } from "../../../../components/JsonLogicInput";
import { VerticalMetadata } from "../../../../components/VerticalMetadata";
import { assert } from "../../../../utils/assert";
import { TruthTable } from "../../data";
import { useMatches, useSelector, useSend } from "../../machine";
import { StaticPropertyInput } from "../StaticPropertyInput";
import { firstPropertyValue, getSelectedRowOutcome, isOutcomeDataMissing } from "./TruthTableBuilder.utils";
import { isFieldComponent } from "../../../../components/DynamicForm";
import { JsonLogicPreview } from "../JsonLogicPreview";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var _createForm = createForm({
    provider: true
  }),
  OutcomeFormProvider = _createForm.FormProvider,
  OutcomeForm = _createForm.Form,
  OutcomeField = _createForm.Field;
var _createForm2 = createForm({
    provider: true
  }),
  ConditionsFormProvider = _createForm2.FormProvider,
  ConditionsForm = _createForm2.Form,
  ConditionsField = _createForm2.Field,
  useFieldArray = _createForm2.useFieldArray;
var _createForm3 = createForm({
    provider: true
  }),
  OutcomeDataFormProvider = _createForm3.FormProvider,
  OutcomeDataForm = _createForm3.Form,
  OutcomeDataField = _createForm3.Field;

/**
 * A UI for building a truth table block
 */
export function TruthTableBuilder(_ref) {
  var _selectedNode$data$pr;
  var propertyKey = _ref.propertyKey,
    propertySchema = _ref.propertySchema,
    invalid = _ref.invalid;
  var matches = useMatches();
  var send = useSend();
  var selectedNode = useSelector(function (context) {
    return context.workflow.nodes.find(function (node) {
      return node.id === context.selectedNodeId;
    });
  });
  var propertyValue = TruthTable["default"]({
    defaultOutcome: '',
    rows: []
  }).parse(selectedNode === null || selectedNode === void 0 ? void 0 : (_selectedNode$data$pr = selectedNode.data.properties) === null || _selectedNode$data$pr === void 0 ? void 0 : _selectedNode$data$pr[propertyKey]);
  return _jsxs(Flex, {
    direction: "column",
    gap: 6,
    children: [_jsx(Case, {
      propertyKey: propertyKey,
      row: {
        outcome: {
          id: propertyValue.defaultOutcome
        },
        conditions: {
          and: []
        }
      },
      rowIdx: "default",
      invalid: invalid,
      schema: propertySchema
    }), propertyValue.rows.map(function (row, idx) {
      return _jsx(Case, {
        propertyKey: propertyKey,
        rowIdx: idx,
        row: row,
        invalid: invalid,
        schema: propertySchema
      }, idx);
    }), _jsx("div", {
      children: _jsx(Button, {
        intent: "primary",
        emphasis: "outlined",
        width: "hug",
        onClick: function onClick() {
          send({
            type: 'ADD_CASE',
            payload: {
              propertyKey: propertyKey
            }
          });
        },
        children: "Add new case"
      })
    }), (matches('step_3.adding_outcome') || matches('step_3.editing_outcome')) && _jsx(OutcomeDialog, {
      propertyKey: propertyKey
    }), matches('step_3.editing_conditions') && _jsx(ConditionsDialog, {
      propertyKey: propertyKey,
      propertySchema: propertySchema
    }), matches('step_3.editing_outcome_data') && _jsx(OutcomeDataDialog, {
      propertyKey: propertyKey
    })]
  });
}

/**
 * A case in the truth table block which shows the outcome, conditions, and
 * outcome data
 */
function Case(_ref2) {
  var _outcomes$find, _outcomes$filter;
  var propertyKey = _ref2.propertyKey,
    rowIdx = _ref2.rowIdx,
    row = _ref2.row,
    invalid = _ref2.invalid,
    schema = _ref2.schema;
  var conditions = row.conditions,
    outcome = row.outcome;
  var send = useSend();
  var outcomes = useSelector(function (context) {
    var _context$workflow$nod;
    return (_context$workflow$nod = context.workflow.nodes.find(function (node) {
      return node.id === context.selectedNodeId;
    })) === null || _context$workflow$nod === void 0 ? void 0 : _context$workflow$nod.data.outcomes;
  });
  var outcomeDataSchema = outcomes === null || outcomes === void 0 ? void 0 : (_outcomes$find = outcomes.find(function (outcomeDef) {
    return outcomeDef.id === outcome.id;
  })) === null || _outcomes$find === void 0 ? void 0 : _outcomes$find.data;
  var outcomeDataItemSchema = firstPropertyValue((outcomeDataSchema === null || outcomeDataSchema === void 0 ? void 0 : outcomeDataSchema.properties) || {});
  var caseHeadingId = useId();
  var conditionsHeadingId = useId();
  var outcomeDataHeadingId = useId();
  return _jsx("section", {
    "aria-labelledby": caseHeadingId,
    children: _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsxs(Flex, {
        align: "center",
        justify: "between",
        children: [_jsx(Heading, {
          level: 4,
          variant: "titleS",
          id: caseHeadingId,
          children: rowIdx === 'default' ? 'Case 1 (default)' : "Case ".concat(rowIdx + 2)
        }), rowIdx !== 'default' && _jsx(Flex.Item, {
          grow: 0,
          children: _jsx(Button, {
            "aria-label": "Delete case",
            leadIcon: DeleteOutlineIcon,
            emphasis: "highlighted",
            onClick: function onClick() {
              send({
                type: 'DELETE_CASE',
                payload: {
                  rowIdx: rowIdx,
                  propertyKey: propertyKey
                }
              });
            }
          })
        })]
      }), _jsxs(Flex, {
        gap: 2,
        children: [_jsx(Flex.Item, {
          grow: 1,
          children: _jsxs(Select, {
            onChange: function onChange(value) {
              if (value === 'create_new_outcome') {
                send({
                  type: 'ADD_OUTCOME',
                  payload: {
                    rowIdx: rowIdx
                  }
                });
              } else {
                send({
                  type: 'CHANGE_OUTCOME',
                  payload: {
                    rowIdx: rowIdx,
                    outcomeId: value,
                    propertyKey: propertyKey
                  }
                });
              }
            },
            value: outcome.id,
            appearance: "styled",
            label: "Outcome",
            required: true,
            invalid: invalid && !outcome.id,
            helpText: invalid && !outcome.id ? 'Outcome is required' : undefined,
            children: [outcomes === null || outcomes === void 0 ? void 0 : (_outcomes$filter = outcomes.filter(function (outcome) {
              return rowIdx !== 'default' || !outcome.data;
            })) === null || _outcomes$filter === void 0 ? void 0 : _outcomes$filter.map(function (outcome) {
              return _jsx(Select.Option, {
                label: outcome.displayName,
                value: outcome.id
              }, outcome.id);
            }), _jsx(Divider, {
              m: 0
            }), _jsx(Select.Option, {
              label: "Create new outcome",
              value: "create_new_outcome",
              icon: PlusOutlineIcon
            })]
          })
        }), outcome.id && _jsx(Box, {
          pt: 8,
          children: _jsx(Button, {
            "aria-label": "Edit outcome",
            leadIcon: EditOutlineIcon,
            emphasis: "highlighted",
            intent: "primary",
            onClick: function onClick() {
              send({
                type: 'EDIT_OUTCOME',
                payload: {
                  rowIdx: rowIdx
                }
              });
            }
          })
        })]
      }), rowIdx !== 'default' && _jsxs(_Fragment, {
        children: [_jsxs(Flex, {
          direction: "column",
          gap: 2,
          children: [_jsx(Heading, {
            level: 5,
            variant: "labelM",
            id: conditionsHeadingId,
            children: "Conditions"
          }), conditions && conditions.and.length > 0 && _jsx(Card, {
            "aria-labelledby": conditionsHeadingId,
            children: _jsxs(Flex, {
              gap: 2,
              justify: "between",
              children: [_jsx(Flex, {
                direction: "column",
                gap: 2,
                children: conditions.and.map(function (condition, idx) {
                  return _jsx(JsonLogicPreview, {
                    values: condition,
                    acceptedObjects: schema['x-acceptedObjects'],
                    variant: "stacked"
                  }, idx);
                })
              }), _jsx(Flex.Item, {
                shrink: 0,
                children: _jsx(Button, {
                  "aria-label": "Edit conditions",
                  leadIcon: EditOutlineIcon,
                  emphasis: "transparent",
                  intent: "primary",
                  onClick: function onClick() {
                    send({
                      type: 'EDIT_CONDITIONS',
                      payload: {
                        rowIdx: rowIdx
                      }
                    });
                  }
                })
              })]
            })
          }), (conditions === null || conditions === void 0 ? void 0 : conditions.and.length) === 0 && _jsxs("section", {
            "aria-labelledby": conditionsHeadingId,
            children: [_jsx(Button, {
              emphasis: "transparent",
              intent: "primary",
              onClick: function onClick() {
                send({
                  type: 'EDIT_CONDITIONS',
                  payload: {
                    rowIdx: rowIdx
                  }
                });
              },
              children: "Add"
            }), invalid && _jsx(HelpText, {
              intent: "negative",
              showIcon: true,
              children: "Must add at least one condition"
            })]
          })]
        }), outcomeDataItemSchema && _jsxs(Flex, {
          direction: "column",
          gap: 2,
          children: [_jsx(Heading, {
            level: 5,
            variant: "labelM",
            id: outcomeDataHeadingId,
            children: "Outcome data"
          }), isOutcomeDataMissing(outcome.data) ? _jsxs("section", {
            "aria-labelledby": outcomeDataHeadingId,
            children: [_jsx(Button, {
              emphasis: "transparent",
              intent: "primary",
              onClick: function onClick() {
                send({
                  type: 'EDIT_OUTCOME_DATA',
                  payload: {
                    rowIdx: rowIdx
                  }
                });
              },
              children: "Add"
            }), invalid && _jsx(HelpText, {
              intent: "negative",
              showIcon: true,
              children: "Must add outcome data"
            })]
          }) : _jsx(Card, {
            "aria-labelledby": outcomeDataHeadingId,
            children: _jsxs(Flex, {
              gap: 1,
              children: [_jsx(Flex.Item, {
                grow: 1,
                children: _jsx(OutcomeDataDisplay, {
                  data: outcome.data
                })
              }), _jsx(Flex.Item, {
                grow: 0,
                children: _jsx(Button, {
                  "aria-label": "Edit outcome data",
                  leadIcon: EditOutlineIcon,
                  emphasis: "transparent",
                  intent: "primary",
                  onClick: function onClick() {
                    send({
                      type: 'EDIT_OUTCOME_DATA',
                      payload: {
                        rowIdx: rowIdx
                      }
                    });
                  }
                })
              })]
            })
          })]
        })]
      })]
    })
  });
}

/**
 * Displays the outcome data in a user-friendly way
 */
function OutcomeDataDisplay(_ref3) {
  var data = _ref3.data;
  var value = firstPropertyValue(data || {});
  var components = useSelector(function (context) {
    return context.form.components.filter(isFieldComponent);
  });
  return _jsx(_Fragment, {
    children: match(value)["with"](P.nullish, function () {
      throw new Error('Missing outcome data');
    })["with"](P.string, function (value) {
      return _jsx(Text, {
        wordBreak: "word",
        children: value
      });
    })["with"]({
      question_key: P.string,
      option_keys: P.array(P.string)
    }, function (_ref4) {
      var question_key = _ref4.question_key,
        option_keys = _ref4.option_keys;
      var component = components.find(function (component) {
        return component.key === question_key;
      });
      if (!component) {
        return _jsx(HelpText, {
          showIcon: true,
          intent: "warning",
          children: "Missing question! It may have been removed from the form. Please select a different question"
        });
      }
      if ('data' in component && 'url' in component.data) {
        return _jsx(HelpText, {
          showIcon: true,
          intent: "warning",
          children: "Select with dynamic options is not supported. Please select a different question"
        });
      }
      var options = match(component)["with"]({
        type: 'radio'
      }, function (c) {
        return c.values;
      })["with"]({
        type: 'select'
      }, function (c) {
        assert('values' in c.data, 'dynamic select not supported');
        return c.data.values;
      }).otherwise(function () {
        return [];
      });
      return _jsxs(VerticalMetadata, {
        children: [_jsx(VerticalMetadata.Key, {
          children: "Question"
        }), _jsx(VerticalMetadata.Value, {
          children: component.label
        }), _jsx(VerticalMetadata.Key, {
          children: "Options"
        }), _jsx(VerticalMetadata.Value, {
          children: option_keys.map(function (optionKey, idx) {
            var option = options.find(function (option) {
              return option.value === optionKey;
            });
            if (!option) {
              return _jsxs(Text, {
                as: "span",
                intent: "negative",
                children: [_jsx("i", {
                  children: "Missing option"
                }), idx === option_keys.length - 1 ? '' : ', ']
              });
            }
            return "".concat(option.label).concat(idx === option_keys.length - 1 ? '' : ', ');
          })
        })]
      });
    }).exhaustive()
  });
}

/**
 * The dialog the user can use to add/edit an outcome of the truth table block
 */
function OutcomeDialog(_ref5) {
  var propertyKey = _ref5.propertyKey;
  var send = useSend();
  var id = useId();
  var matches = useMatches();
  var defaultValues = useSelector(function (context) {
    var _existingOutcome$data, _existingOutcome$data2;
    if (matches('step_3.adding_outcome')) {
      return {
        id: shortUUID(),
        displayName: '',
        outcomeDataId: '',
        outcomeDataType: '',
        outcomeDataName: ''
      };
    }
    var existingOutcome = getSelectedRowOutcome({
      context: context,
      propertyKey: propertyKey
    });
    var outcomeDataItem = firstPropertyValue(((_existingOutcome$data = existingOutcome.data) === null || _existingOutcome$data === void 0 ? void 0 : _existingOutcome$data.properties) || {});
    return {
      id: existingOutcome.id,
      displayName: existingOutcome.displayName,
      outcomeDataId: Object.keys(((_existingOutcome$data2 = existingOutcome.data) === null || _existingOutcome$data2 === void 0 ? void 0 : _existingOutcome$data2.properties) || {})[0],
      outcomeDataType: match(outcomeDataItem)["with"](P.nullish, function () {
        return '';
      })["with"]({
        'x-type': 'form-question-options'
      }, function () {
        return 'form-question-options';
      })["with"]({
        type: 'string'
      }, function () {
        return 'string';
      }).exhaustive(),
      outcomeDataName: (outcomeDataItem === null || outcomeDataItem === void 0 ? void 0 : outcomeDataItem.title) || ''
    };
  });
  var defaultOutcomeId = useSelector(function (context) {
    var _selectedNode$data$pr2;
    var selectedNode = context.workflow.nodes.find(function (node) {
      return node.id === context.selectedNodeId;
    });
    var propertyValue = TruthTable["default"]({
      defaultOutcome: '',
      rows: []
    }).parse(selectedNode === null || selectedNode === void 0 ? void 0 : (_selectedNode$data$pr2 = selectedNode.data.properties) === null || _selectedNode$data$pr2 === void 0 ? void 0 : _selectedNode$data$pr2[propertyKey]);
    return propertyValue.defaultOutcome;
  });
  var selectedRowIdx = useSelector(function (context) {
    return context.selectedRowIdx;
  });
  return _jsx(OutcomeFormProvider, {
    defaultValues: defaultValues,
    onSubmit: function onSubmit(_ref6) {
      var id = _ref6.id,
        displayName = _ref6.displayName,
        outcomeDataId = _ref6.outcomeDataId,
        outcomeDataName = _ref6.outcomeDataName,
        outcomeDataType = _ref6.outcomeDataType;
      if (!outcomeDataName && !outcomeDataType) {
        send({
          type: 'CONFIRM_OUTCOME',
          payload: {
            propertyKey: propertyKey,
            outcome: {
              id: id,
              displayName: displayName
            }
          }
        });
        return;
      }
      assert(outcomeDataType === 'form-question-options' || outcomeDataType === 'string', 'Invalid outcome data type');
      send({
        type: 'CONFIRM_OUTCOME',
        payload: {
          propertyKey: propertyKey,
          outcome: {
            id: id,
            displayName: displayName,
            data: {
              type: 'object',
              properties: _defineProperty({}, outcomeDataId || shortUUID(), match(outcomeDataType)["with"]('form-question-options', function () {
                return {
                  title: outcomeDataName,
                  'x-type': 'form-question-options',
                  type: 'object',
                  properties: {
                    option_keys: {
                      type: 'array',
                      items: {
                        type: 'string',
                        format: 'form-question-option-short'
                      }
                    },
                    question_key: {
                      type: 'string',
                      format: 'form-question'
                    }
                  }
                };
              })["with"]('string', function () {
                return {
                  title: outcomeDataName,
                  type: 'string'
                };
              }).exhaustive())
            }
          }
        }
      });
    },
    children: _jsxs(Dialog, {
      open: true,
      onOpenChange: function onOpenChange(open) {
        if (!open) {
          send({
            type: 'CANCEL_OUTCOME'
          });
        }
      },
      children: [_jsx(Dialog.Heading, {
        children: matches('step_3.adding_outcome') ? 'Create New Outcome' : 'Edit Outcome'
      }), _jsx(Dialog.Content, {
        children: _jsx(OutcomeForm, {
          id: id,
          children: _jsxs(Flex, {
            direction: "column",
            gap: 6,
            children: [_jsx(OutcomeField, {
              name: "displayName",
              label: "Outcome name",
              as: TextInput,
              required: "Outcome name is required",
              size: "sm"
            }), defaultValues.id !== defaultOutcomeId && selectedRowIdx !== 'default' && _jsxs(Flex, {
              direction: "column",
              gap: 4,
              children: [_jsx(Heading, {
                level: 3,
                variant: "titleS",
                children: "Outcome Data"
              }), _jsx(OutcomeField, {
                name: "outcomeDataName",
                label: "Data name",
                as: TextInput,
                validate: function validate(value, _ref7) {
                  var values = _ref7.values;
                  if (!value && values.outcomeDataType) {
                    return 'Name is required when adding outcome data';
                  }
                  return true;
                }
              }), _jsxs(OutcomeField, {
                name: "outcomeDataType",
                as: Select,
                label: "Data type",
                validate: function validate(value, _ref8) {
                  var values = _ref8.values;
                  if (!value && values.outcomeDataName) {
                    return 'Data type is required when adding outcome data';
                  }
                  return true;
                },
                appearance: "styled",
                children: [_jsx(Select.Option, {
                  value: "form-question-options",
                  label: "Question responses"
                }), _jsx(Select.Option, {
                  value: "string",
                  label: "Text"
                })]
              })]
            })]
          })
        })
      }), _jsxs(Dialog.Actions, {
        children: [_jsx(Button, {
          intent: "secondary",
          emphasis: "highlighted",
          onClick: function onClick() {
            send({
              type: 'CANCEL_OUTCOME'
            });
          },
          width: "fill",
          children: "Cancel"
        }), _jsx(Button, {
          intent: "primary",
          type: "submit",
          width: "fill",
          form: id,
          children: matches('step_3.adding_outcome') ? 'Create' : 'Update'
        })]
      })]
    })
  });
}

/**
 * The dialog the user can use to add/edit the conditions which activate a row
 * in the truth table
 */
function ConditionsDialog(_ref9) {
  var propertyKey = _ref9.propertyKey,
    propertySchema = _ref9.propertySchema;
  var send = useSend();
  var id = useId();
  var conditions = useSelector(function (context) {
    var _selectedNode$data$pr3;
    if (typeof context.selectedRowIdx !== 'number') return [];
    var selectedNode = context.workflow.nodes.find(function (node) {
      return node.id === context.selectedNodeId;
    });
    var propertyValue = TruthTable["default"]({
      defaultOutcome: '',
      rows: []
    }).parse(selectedNode === null || selectedNode === void 0 ? void 0 : (_selectedNode$data$pr3 = selectedNode.data.properties) === null || _selectedNode$data$pr3 === void 0 ? void 0 : _selectedNode$data$pr3[propertyKey]);
    return propertyValue.rows[context.selectedRowIdx].conditions.and;
  });
  var isAdding = conditions.length === 0;
  return _jsx(ConditionsFormProvider, {
    defaultValues: {
      conditions: isAdding ? [{
        "in": [{
          "var": ''
        }, []]
      }] : conditions
    },
    onSubmit: function onSubmit(values) {
      send({
        type: 'CONFIRM_EDITING_CONDITIONS',
        payload: {
          propertyKey: propertyKey,
          conditions: {
            and: values.conditions
          }
        }
      });
    },
    children: _jsxs(Dialog, {
      open: true,
      onOpenChange: function onOpenChange(open) {
        if (!open) {
          send({
            type: 'CANCEL_EDITING_CONDITIONS'
          });
        }
      },
      children: [_jsx(Dialog.Heading, {
        children: isAdding ? 'Add conditions' : 'Edit conditions'
      }), _jsx(Dialog.Content, {
        children: _jsx(ConditionsForm, {
          id: id,
          children: _jsx(ConditionsList, {
            propertySchema: propertySchema
          })
        })
      }), _jsxs(Dialog.Actions, {
        children: [_jsx(Button, {
          intent: "secondary",
          emphasis: "highlighted",
          onClick: function onClick() {
            send({
              type: 'CANCEL_EDITING_CONDITIONS'
            });
          },
          width: "fill",
          children: "Cancel"
        }), _jsx(Button, {
          intent: "primary",
          width: "fill",
          type: "submit",
          form: id,
          children: conditions.length === 0 ? 'Add' : 'Update'
        })]
      })]
    })
  });
}

/**
 * The list of conditions the user has added to the truth table row
 */
function ConditionsList(_ref10) {
  var propertySchema = _ref10.propertySchema;
  var _useFieldArray = useFieldArray({
      name: 'conditions'
    }),
    fields = _useFieldArray.fields,
    append = _useFieldArray.append,
    remove = _useFieldArray.remove;
  var addButtonRef = useRef(null);
  var deleteButtonsRef = useRef({});
  return _jsxs(Flex, {
    gap: 6,
    direction: "column",
    children: [fields.map(function (field, idx) {
      return _jsxs(Flex, {
        as: "section",
        "aria-labelledby": field.id,
        direction: "column",
        gap: 4,
        children: [_jsxs(Flex, {
          align: "center",
          justify: "between",
          children: [_jsxs(Heading, {
            id: field.id,
            level: 2,
            variant: "titleS",
            children: ["Condition ", idx + 1]
          }), fields.length > 1 && _jsx(Button, {
            onClick: function onClick() {
              var nextField = fields[idx + 1];
              var prevField = fields[idx - 1];
              if (nextField) {
                var _deleteButtonsRef$cur;
                (_deleteButtonsRef$cur = deleteButtonsRef.current[nextField.id]) === null || _deleteButtonsRef$cur === void 0 ? void 0 : _deleteButtonsRef$cur.focus();
              } else if (prevField && idx !== 1) {
                var _deleteButtonsRef$cur2;
                (_deleteButtonsRef$cur2 = deleteButtonsRef.current[prevField.id]) === null || _deleteButtonsRef$cur2 === void 0 ? void 0 : _deleteButtonsRef$cur2.focus();
              } else {
                var _addButtonRef$current;
                (_addButtonRef$current = addButtonRef.current) === null || _addButtonRef$current === void 0 ? void 0 : _addButtonRef$current.focus();
              }
              remove(idx);
            },
            ref: function ref(el) {
              if (el) {
                deleteButtonsRef.current[field.id] = el;
              } else {
                delete deleteButtonsRef.current[field.id];
              }
            },
            emphasis: "highlighted",
            leadIcon: DeleteOutlineIcon,
            "aria-label": "Delete condition ".concat(idx + 1),
            size: "sm"
          })]
        }), _jsx(ConditionsField, {
          name: "conditions.".concat(idx),
          as: JsonLogicInput,
          acceptedObjects: propertySchema['x-acceptedObjects'],
          validate: validateJsonLogicFieldValue
        })]
      }, field.id);
    }), _jsx(Flex.Item, {
      children: _jsx(Button, {
        intent: "primary",
        emphasis: "outlined",
        onClick: function onClick() {
          return append({
            "in": [{
              "var": ''
            }, []]
          });
        },
        ref: addButtonRef,
        children: "Add new condition"
      })
    })]
  });
}

/**
 * The dialog the user can use to add/edit the outcome data of a truth table row
 */
function OutcomeDataDialog(_ref11) {
  var _outcomeDef$data, _outcomeDef$data2;
  var propertyKey = _ref11.propertyKey;
  var send = useSend();
  var id = useId();
  var outcomeDef = useSelector(function (context) {
    return getSelectedRowOutcome({
      context: context,
      propertyKey: propertyKey
    });
  });
  var outcomeDataId = Object.keys(((_outcomeDef$data = outcomeDef.data) === null || _outcomeDef$data === void 0 ? void 0 : _outcomeDef$data.properties) || {})[0];
  var outcomeDataSchema = firstPropertyValue(((_outcomeDef$data2 = outcomeDef.data) === null || _outcomeDef$data2 === void 0 ? void 0 : _outcomeDef$data2.properties) || {});
  assert(outcomeDataSchema, 'Outcome data item schema not found');
  assert(outcomeDataId, 'Outcome data id not found');
  var outcomeData = useSelector(function (context) {
    var _selectedNode$data$pr4;
    var selectedNodeId = context.selectedNodeId;
    var selectedRowIdx = context.selectedRowIdx;
    assert(selectedNodeId);
    assert(typeof selectedRowIdx === 'number');
    var selectedNode = context.workflow.nodes.find(function (node) {
      return node.id === selectedNodeId;
    });
    var propertyValue = TruthTable["default"]({
      defaultOutcome: '',
      rows: []
    }).parse(selectedNode === null || selectedNode === void 0 ? void 0 : (_selectedNode$data$pr4 = selectedNode.data.properties) === null || _selectedNode$data$pr4 === void 0 ? void 0 : _selectedNode$data$pr4[propertyKey]);
    return propertyValue.rows[selectedRowIdx].outcome.data;
  });
  var isAdding = isOutcomeDataMissing(outcomeData);
  var outcomeDataItem = firstPropertyValue(outcomeData || {});
  return _jsx(OutcomeDataFormProvider, {
    defaultValues: {
      data: outcomeDataItem
    },
    onSubmit: function onSubmit(_ref12) {
      var data = _ref12.data;
      assert(typeof data === 'string' || isMatching({
        option_keys: P.array(P.string),
        question_key: P.string
      }, data));
      send({
        type: 'CONFIRM_OUTCOME_DATA',
        payload: {
          propertyKey: propertyKey,
          data: _defineProperty({}, outcomeDataId, data)
        }
      });
    },
    children: _jsxs(Dialog, {
      open: true,
      onOpenChange: function onOpenChange(open) {
        if (!open) {
          send({
            type: 'CANCEL_OUTCOME_DATA'
          });
        }
      },
      children: [_jsx(Dialog.Heading, {
        children: isAdding ? 'Add outcome data' : 'Edit outcome data'
      }), _jsx(Dialog.Content, {
        children: _jsx(OutcomeDataForm, {
          id: id,
          children: _jsx(OutcomeDataField, {
            name: "data",
            as: StaticPropertyInput,
            required: "Outcome data is required",
            schema: outcomeDataSchema
          })
        })
      }), _jsxs(Dialog.Actions, {
        children: [_jsx(Button, {
          intent: "secondary",
          emphasis: "highlighted",
          onClick: function onClick() {
            send({
              type: 'CANCEL_OUTCOME_DATA'
            });
          },
          width: "fill",
          children: "Cancel"
        }), _jsx(Button, {
          intent: "primary",
          type: "submit",
          width: "fill",
          form: id,
          children: isAdding ? 'Add' : 'Update'
        })]
      })]
    })
  });
}